const generateBook = (book) => {
  let price = 19.99;
  if (book.saleInfo.saleability === "FOR_SALE" && book.saleInfo.saleability > 9) {
    price = book.saleInfo.saleability;
  }

  return {
    id:           book.id,
    title:        book.volumeInfo?.title,
    subtitle:     book.volumeInfo?.subtitle || null,
    author:       book.volumeInfo?.authors?.[0] || null,
    description:  book.searchInfo?.textSnippet || null,
    thumbnail:    book.volumeInfo?.imageLinks?.thumbnail?.replace("http", "https") || "/foreword/images/book.png",
    price:        price
  };
}

const searchBooks = (name, callback) => {
  fetch("https://www.googleapis.com/books/v1/volumes?maxResults=6&q=" + encodeURIComponent(name))
    .then((response) => response.json())
    .then((data) => {
      if (data.totalItems === 0) {
        callback(null);
        return;
      }

      const books = data.items.map((volume) => generateBook(volume));
      (books.length === 0) ? callback(null) : callback(books);
    });
}

const getBookByID = (ID, callback) => {
  fetch("https://www.googleapis.com/books/v1/volumes/" + encodeURIComponent(ID))
    .then((response) => response.json())
    .then((volume) => { callback(generateBook(volume)); });
}

const getBookByIDAsync = async (ID) => {
  const response = await fetch("https://www.googleapis.com/books/v1/volumes/" + encodeURIComponent(ID));
  const volume = await response.json();
  return generateBook(volume);
}

export { searchBooks, getBookByID, getBookByIDAsync };
